<template>
  <div class="metafield-edit-video">
    <p class="metafield__title" v-if="embedPreviewCode">{{ field.label }}</p>
    <div class="metafield-edit-video__player" v-if="embedPreviewCode" v-html="embedPreviewCode"></div>
    <div class="metafield-edit-video__controls" v-if="!showInput">
      <BaseButton title="Change Video" @click.native="showInput = true"/>
      <BaseButton title="Remove Video" @click.native="onInput(null)"/>
    </div>
    <BaseInput
      :data-vv-as="'video url'"
      v-show="showInput"
      :name="$attrs.name"
      label="Video url"
      :value="url"
      :hint="hint"
      @input="onInput"
      validate="url"
      ></BaseInput>
  </div>
</template>

<script>
import { videoEmbedHelper } from '@/helpers'
import { forSingleMetafield } from '@/mixins/metafields-changed-detection.mixin'

export default {
  inject: ['$validator'],
  mixins: [ forSingleMetafield(true) ],
  props: {
    field: Object,
    value: String,
    hint: String,
    subFormData: Object
  },
  data () {
    return {
      url: null,
      showInput: !this.value,
      embedPreviewCode: null,
      embedCode: null
    }
  },
  methods: {
    onInput (val) {

      if (!val) {
        this.url = null
        this.embedCode = null
        this.embedPreviewCode = null
        this.showInput = true
        return this.$emit('input', this.embedCode)
      }

      this.url = val
      this.embedCode = this.getEmbedCode()
      this.embedPreviewCode = this.getEmbedPreviewCode()
      this.$emit('input', this.embedCode)

      if (this.embedPreviewCode) {
        this.showInput = false
      }
    },

    getEmbedPreviewCode () {
      if (!this.embedCode) {
        return null
      }
      
      let _codePreview = this.embedCode
      _codePreview = _codePreview.replace(`autoplay=true`, 'autoplay=0')

      return _codePreview
    },

    getEmbedCode () {
      return videoEmbedHelper.getEmbedCode({
        link: this.url,
        params: {
          width: this.subFormData.width,
          height: this.subFormData.height,
          autoplay:  this.subFormData.autoplay,
          allowFullScreen: this.subFormData.allowFullScreen
        }
      })
    }
  },

  mounted () {
    if (this.value) {

      let _newValue = this.value
      const { iframeFullscreenParams } = videoEmbedHelper
      
      // Update value according to this.subFormData.autoplay and this.subFormData.allowFullScreen
      _newValue = _newValue.replace(/autoplay=([^"]*)/, `autoplay=${this.subFormData.autoplay}`)
      
      if (this.subFormData.allowFullScreen) {
        if (!_newValue.includes(iframeFullscreenParams)) {
          const separator = '></iframe>'
          const strArr = _newValue.split(separator)
          _newValue = strArr[0] + ' ' + iframeFullscreenParams + separator
        }
      } else {
        if (_newValue.includes(iframeFullscreenParams)) {
          _newValue = _newValue.replace(iframeFullscreenParams, '')
        }
      }

      this.embedCode = _newValue
      this.$emit('input', this.embedCode)
      this.embedPreviewCode = this.getEmbedPreviewCode()
    }
  }
}
</script>

<style lang="scss">
  .metafield-edit-video {
    display: block;

    .BaseCollapse {
      padding: 0 1px;
    }
    
    &__player {
      display: block;
      position: relative;
      width: 100%;
      height: 0;
      padding-bottom: 56.25%;

      iframe {
        position: absolute;
        top: 0;
        left: 0;
        width: 100%;
        height: 100%;
      }
    }
    
    &__controls {
      text-align: center;

      button { 
        margin: 10px 4px;
      }
    }

    .base-input {
      margin: 10px 0;
    }
  }
</style>



// WEBPACK FOOTER //
// src/components/metafields-edit/metafields/MetafieldEditVideo.vue